import { render, staticRenderFns } from "./FileInputField.vue?vue&type=template&id=38ba6774&scoped=true"
import script from "./FileInputField.vue?vue&type=script&lang=js"
export * from "./FileInputField.vue?vue&type=script&lang=js"
import style0 from "./FileInputField.vue?vue&type=style&index=0&id=38ba6774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba6774",
  null
  
)

export default component.exports